<div class="history-list" *ngIf="history">
  <table class="history-table" mat-table [dataSource]="history" matSort (matSortChange)="changeSort($event)">
    <ng-container matColumnDef="when">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> When </th>
      <td mat-cell  *matCellDef="let history"> {{getWhen(history.dateTimeEpochSecs)}} </td>
    </ng-container>
    <ng-container matColumnDef="fieldname">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Field </th>
      <td mat-cell  *matCellDef="let history"> {{history.entityField}} </td>
    </ng-container>
    <ng-container matColumnDef="patient">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Patient </th>
      <td mat-cell  *matCellDef="let history">{{getPatient(history)}} </td>
    </ng-container>
    <ng-container matColumnDef="operation">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Operation </th>
      <td mat-cell  *matCellDef="let history"> {{history.operationType |titlecase}} </td>
    </ng-container>
    <ng-container matColumnDef="value">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Value </th>
      <td mat-cell  *matCellDef="let history"> {{history.fieldValue}} </td>
    </ng-container>
   
  
    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns;"></tr>
  </table>